import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useSubMenu } from "../../../../empreenderUI/SubMenuContext";
import { getPersonalizarContentId } from "./routeMap";
import { ensureContentOpen } from "./ensureContentOpen";

/**
 * Abre o Content correspondente à rota /personalizar/*.
 * Ex.: /personalizar/marca-agua → ensureContentOpen("marca-agua")
 */
const usePersonalizarRouteSync = () => {
	const { pathname } = useLocation();
	const { state, toggle } = useSubMenu();
	const lastPathRef = useRef(null);

	useEffect(() => {
		if (lastPathRef.current === pathname) return;
		lastPathRef.current = pathname;

		const contentId = getPersonalizarContentId(pathname);
		if (!contentId) return;
		ensureContentOpen(contentId, { state, toggle });
	}, [pathname, state, toggle]);
};

export default usePersonalizarRouteSync;
